import React, { Component } from "react";
import { Wrapper } from "app/NativeComponents/common";
import Intercom, { IntercomAPI } from "react-intercom";

import moment from "moment";

class IntercomWrapper extends Component {
  componentDidMount() {
    this.props.triggerIntercom(false);
    clearInterval(this._interval);

    this._interval = setTimeout(() => {
      this.props.triggerIntercom(true);
    }, 100);
  }

  componentWillUnmount() {
    clearInterval(this._interval);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.trackingEvent != null &&
      this.props.trackingEvent != prevProps.trackingEvent
    ) {
      if (this.props.trackingEvent.startsWith("intercom_")) {
        const event_id = this.props.trackingEvent.replace("intercom_", "");
        IntercomAPI("trackEvent", event_id);
      }
    }
  }

  render() {
    var intercom_data = {
      alignment: "right",
      custom_launcher_selector: "#intercom_button"
    };

    if (this.props.user) {
      intercom_data = {
        user_id: this.props.user.id,
        email: this.props.user.email,
        name: this.props.user.firstname + " " + this.props.user.lastname,
        phone: this.props.user.phone,
        signed_up_at: moment(this.props.user.date_created).format("X"),
        custom_attributes: this.props.user.intercom_data,
        alignment: "right",
        custom_launcher_selector: "#intercom_button",
        user_hash: this.props.user.intercom_hash
          ? this.props.user.intercom_hash
          : null
      };
    }

    if (this.props.trigger_intercom) {
      return <Intercom appID="sfur1js7" {...intercom_data} />;
    }

    return <div />;
  }
}

export default IntercomWrapper;
